import { SidebarTrigger, useSidebar } from '@teach/ui'
import { useMessages } from '@/i18n'
import { cn } from '@/lib/utils'
import { messages } from './messages'
import { useHideOnScrollDown } from './useHideOnScrollDown'

/**
 * На узких экранах открыть навигацию было НЕЧЕМ: `CollapsedSidebarTrigger`
 * отдаёт `null` при `isMobile`, а единственный второй `SidebarTrigger` живёт
 * в подвале самого сайдбара — то есть виден только когда сайдбар уже открыт.
 *
 * Место — НИЗ-слева: сверху кнопка налезала на заголовки страниц («Настройки»),
 * а снизу слева на телефоне ничего нет (тосты и DEV — справа). Отступ снизу
 * учитывает полосу «домой» на iPhone (`safe-area-inset-bottom`). Привязка — к верху на
 * высоте `100svh` (видимая область при ПОКАЗАННЫХ панелях браузера), а не `bottom`:
 * низ в iOS Safari ездит вместе с панелью браузера (обновление, прокрутка), и кнопка
 * уезжала под неё. Так она всегда в одной точке и над панелью. Вид — «стекло»,
 * тот же рецепт, что у плавающих инструментов холста (`EditorWorkspace`).
 *
 * При прокрутке вниз кнопка прячется: `fixed` лежала поверх карточек и мешала читать
 * и нажимать. При прокрутке вверх и у конца страницы возвращается.
 */
export const MobileSidebarTrigger = () => {
  const { isMobile } = useSidebar()
  const m = useMessages(messages)
  const hidden = useHideOnScrollDown()
  if (!isMobile) return null
  return (
    <div
      className={cn(
        'fixed left-[max(1rem,env(safe-area-inset-left))] top-[calc(100svh-env(safe-area-inset-bottom,0px)-1rem-2.75rem)] z-30 transition-[opacity,translate] duration-200 lg:hidden',
        hidden ? 'pointer-events-none translate-y-4 opacity-0' : null,
      )}
    >
      <SidebarTrigger
        className="!h-11 !w-11 rounded-full border border-white/15 bg-background/30 text-foreground/80 shadow-[inset_0_1px_0_rgb(255_255_255/0.18),0_8px_24px_rgb(0_0_0/0.35)] backdrop-blur-xl backdrop-saturate-150 hover:bg-background/40 hover:text-brand [&_svg]:!size-[1.4375rem]"
        aria-label={m.openNavigation}
      />
    </div>
  )
}
